<template>
  <div id="app">
    <router-view />

    <Tabbar route placeholder safe-area-inset-bottom>
      <TabbarItem replace to="/protype" icon="gift-o">最新卡册</TabbarItem>
      <TabbarItem replace to="/" icon="shopping-cart-o">兑换</TabbarItem>
      <TabbarItem replace to="/search" icon="search">物流查询</TabbarItem>
      <TabbarItem replace to="/concat" icon="friends-o">联系我们</TabbarItem>
    </Tabbar>
  </div>
</template>
<script>
import { Tabbar, TabbarItem } from 'vant'
export default {
  components: {
    Tabbar,
    TabbarItem
  }
}

</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
